import { Trans, useTranslation } from 'react-i18next';
import { DeviceCardProps } from '../DeviceCardProps';
import DriveUnitPortControl from '../Controls/DriveUnitPortControl';
import InputControl from '../Controls/InputControl';
import DeviceCardWrapper from '../DeviceCardWrapper';
import { BeamBreakIcon } from '../../../Icons/Bits';
import { useDriveUnitPortRegistry } from '../../../../hooks/controls/useDriveUnitPortRegistry';

const BeamBreakSensorCard = (props: DeviceCardProps) => {
  const { t } = useTranslation();
  const { portControlValue, setPortControlValue, unsupportedRawValue } = useDriveUnitPortRegistry(props, 'sensor_port');

  return (
    <DeviceCardWrapper header={props.header} headerIcon={BeamBreakIcon} initialOpen={props.initialOpen} onDelete={props.onDelete}>
      <DriveUnitPortControl
        {...props}
        parameterName="sensor_port"
        portControlValue={portControlValue}
        setPortControlValue={setPortControlValue}
        unsupportedRawValue={unsupportedRawValue}
        label={<Trans i18nKey="sensor.port">Sensor Port</Trans>}
        labelId="sensor-port-label"
        labelPopoverId="sensor-port-popover"
        labelPopover={t('sensor.port_info_tooltip')}
        selectId="sensor-port"
        selectLabelId="select-sensor-port-label"
      />
      <InputControl
        {...props}
        parameterName="detection_range"
        label={<Trans i18nKey="beamBreakControl.detection_range">Detection Range</Trans>}
        labelId="detection-range"
        labelPopoverId="detection-range-popover"
        labelPopover={t('beamBreakControl.detection_range_info_tooltip')}
        step={0.01}
        min={0}
        max={1}
        maxDecimalPlaces={3}
        unitLabel="m"
      />
    </DeviceCardWrapper>
  );
};

export default BeamBreakSensorCard;
